import Client from '@/classes/Api/Client';

const state = {
  conditions: [],
  loadedLifeSituation: null,

  conditionList: {
    items: [],
    pagination: {},
  },
};

const getters = {};

const mutations = {
  setConditions(state, data) {
    state.conditions = data;
  },
  setLoadedLifeSituation(state, data) {
    state.loadedLifeSituation = data;
  },

  setConditionListItems(state, data) {
    state.conditionList.items = data;
  },
  setConditionListPagination(state, data) {
    state.conditionList.pagination = data;
  },
};

const actions = {
  loadConditions({commit, state}, lifeSituationId) {
    if (lifeSituationId === state.loadedLifeSituation) {
      return;
    }

    return Client.getConditions(lifeSituationId).then((response) => {
      commit('setConditions', response.data);
      commit('setLoadedLifeSituation', lifeSituationId);
    });
  },

  loadConditionList({commit}, filter) {
    return Client.getConditionList(filter).then((response) => {
      commit('setConditionListItems', response.data.data);
      commit('setConditionListPagination', response.data.paginate);
    });
  },

  clear({commit}) {
    commit('setConditions', []);
    commit('setLoadedLifeSituation', null);
  },

  clearConditionList({commit}) {
    commit('setConditionListItems', []);
    commit('setConditionListPagination', {});
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
